import { FC, ReactNode } from 'react';
import { formatDistanceToNow } from 'date-fns';

import { ChevronRight, CircleNotch, Rotate } from '@matrixreq/icons';

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../../primitives/Card';
import { Button } from '../../primitives/Button';
interface Props {
  id: string;
  name: string;
  lastUpdated: string;
  children?: ReactNode;
  onRefreshAction?: () => void;
  onViewAction?: () => void;
  isLoading?: boolean;
}

const AnalyticsTile: FC<Props> = ({
  id,
  name,
  lastUpdated,
  children,
  onRefreshAction,
  onViewAction,
  isLoading,
}) => {
  return (
    <Card
      className="bg-card text-card-foreground flex h-full w-[500px] min-w-[500px] flex-col rounded-md shadow-xl hover:shadow-2xl"
      data-testid={`analytics-tile-${id}`}
    >
      <CardHeader className="flex flex-row justify-between gap-2 border-b px-5 pb-2 pt-4">
        <CardTitle className="text-[1.75rem] font-medium leading-snug text-gray-100">
          {name}
        </CardTitle>

        <Button variant="icon" onPress={onRefreshAction}>
          <Rotate />
        </Button>
      </CardHeader>

      <CardContent className="h-72 min-h-72 flex-grow content-center px-5 py-5 text-sm">
        {isLoading ? (
          <div className="flex h-full items-center justify-center gap-2 text-sm font-light text-gray-100">
            <CircleNotch className="h-4 w-4 animate-spin" />
            <span>Loading data...</span>
          </div>
        ) : (
          children
        )}
      </CardContent>

      <CardFooter className="flex justify-between gap-2 border-t px-5 py-2 text-center leading-10">
        <div className="flex gap-2 text-xs leading-snug text-gray-100">
          Last updated:{' '}
          {isLoading ? (
            <div className="flex items-center space-x-1">
              <div className="h-1 w-1 animate-bounce rounded-full bg-gray-100" />
              <div className="h-1 w-1 animate-bounce rounded-full bg-gray-100 delay-200" />
              <div className="delay-400 h-1 w-1 animate-bounce rounded-full bg-gray-100" />
            </div>
          ) : (
            formatDistanceToNow(new Date(lastUpdated), { addSuffix: true })
          )}
        </div>

        <Button
          variant="secondary"
          iconRight={<ChevronRight />}
          onPress={onViewAction}
        >
          View
        </Button>
      </CardFooter>
    </Card>
  );
};

export { AnalyticsTile };
